import { PAXES_ADULT_TYPE, PAXES_CHILDREN_TYPE } from '../../commons/utils';
import { USED_FORMAT_DATE, isBetweenPeriod } from '../../commons/datesUtils';

import { translate } from '../../commons/localize';

function getServiceFromListByCode(code, servicesList) {
  if (!code) return undefined;

  if (!servicesList || servicesList.length === 0) return undefined;

  return servicesList.find(service => (service.id === code));
}

function filterServicesByDate(fromDate, toDate, servicesList) {
  if (!servicesList) return [];

  if (!fromDate) return servicesList;

  if (!toDate) return servicesList;

  let finalList = servicesList.map((service) => {
    const { datesList } = service;

    const filteredDates = datesList.map((dateOption) => {
      const { label } = dateOption;

      if (!isBetweenPeriod(label, fromDate, toDate, USED_FORMAT_DATE)) return undefined;

      return dateOption;
    }).filter((x) => (x !== undefined));

    if (!filteredDates || filteredDates.length === 0) return undefined;

    return {
      ...service,
      datesList: filteredDates
    };
  });

  return finalList.filter((x) => (x !== undefined));
}

function filterServicesByDistribution(distribution, servicesList) {
  if (!servicesList) return [];

  if (!distribution) return servicesList;

  const { adults, children } = distribution;

  if (adults === undefined || children === undefined) return servicesList;

  return servicesList.filter((service) => {
    const { paxType } = service;

    if (paxType === PAXES_CHILDREN_TYPE && children > 0) return service;

    if (paxType === PAXES_ADULT_TYPE && adults > 0) return service;

    return undefined;
  }).filter(x => (x !== undefined));
}

function filterServicesByMealPlan(mealPlan, servicesList) {
  if (!servicesList) return [];

  if (!mealPlan) return servicesList;

  return servicesList.filter((service) => {
    const { mealPlan: serviceMealPlan } = service;

    if (serviceMealPlan === '' || mealPlan === serviceMealPlan) return service;

    return undefined;
  }).filter(x => (x !== undefined));
}

function getUpdatedServicesList(distribution, servicesList, availableServices) {
  const { adults, children } = distribution;

  const updatedList = servicesList.map((service) => {
    const { code, quantity } = service;

    const availableService = getServiceFromListByCode(code, availableServices);

    if (!availableService) return undefined;

    const maxOccupancy = (availableService.paxType === PAXES_CHILDREN_TYPE) ? children : adults;

    if (maxOccupancy === 0) return undefined;

    if (quantity <= maxOccupancy) return service;

    const numberToRest = quantity - maxOccupancy;

    return {
      ...service,
      quantity: (quantity - numberToRest)
    };
  });

  return updatedList.filter(item => (item !== undefined));
}

function getVisualServiceData(service, availableServices){
  const {
    id,
    code,
    quantity,
    date
  } = service;

  if (!code) return translate('error');

  const availableService = getServiceFromListByCode(id, availableServices);

  if (!availableService) return `${translate('servicio')}: ${code} // ${translate('paxes')}: ${quantity} // ${translate('fecha')}: ${date} `;

  const { name } = availableService;

  return `${name} // ${translate('paxes')}: ${quantity} // ${translate('fecha')}: ${date} `;
}

export {
  getServiceFromListByCode,
  filterServicesByDate,
  filterServicesByMealPlan,
  filterServicesByDistribution,
  getUpdatedServicesList,
  getVisualServiceData
};
